import { memo } from "react";
import { Modal } from "../Modal";
import { OverridesConflictsModalAction } from "./OverridesConflictsModalAction";
import { OverridesConflictsModalContent } from "./OverridesConflictsModalContent";
import { ERROR_OVERRIDE_CONFLICTS_TITLE } from "../../../consts/strings";

export const OverridesConflictsModal = memo(({ open, onClose, postcodes }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={ERROR_OVERRIDE_CONFLICTS_TITLE}
      content={<OverridesConflictsModalContent postcodes={postcodes} />}
      actions={<OverridesConflictsModalAction onCancel={onClose} />}
      maxWidth={"sm"}
    />
  );
});
